import { selectMode, setMode } from 'store/applicationSlice'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import styles from './ApplicationMainTabs.module.css'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

interface ApplicationMainTabsProps {
    
}

export const ApplicationMainTabs = (props: ApplicationMainTabsProps): JSX.Element => {
    const mode = useAppSelector(selectMode)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const propertySpyTabClasses = classNames(styles.ApplicationMainTabs__Tab, {
        [styles[`ApplicationMainTabs__Tab--Active`]]: mode === 'property',
    })

    const marketSpyTabClasses = classNames(styles.ApplicationMainTabs__Tab, {
        [styles[`ApplicationMainTabs__Tab--Active`]]: mode === 'market',
    })

    const handleToMarketSpy = () => {
        dispatch(setMode('market'))
        navigate("/market")
    }

    const handleToPropertySpy = () => {
        dispatch(setMode('property'))
        navigate("/competitors")
    }

    const handlePropertySpyClick = () => {
        handleToPropertySpy()
    }

    const handleMarketSpyClick = () => {
        handleToMarketSpy()
    }

    return (
        <div className={styles.ApplicationMainTabs}>
            <div className={styles.ApplicationMainTabs__Tabs}>
                <div
                    className={propertySpyTabClasses}
                    onClick={handlePropertySpyClick}
                >
                    Property Spy
                </div>
                <div
                    className={marketSpyTabClasses}
                    onClick={handleMarketSpyClick}
                >
                    Market Spy</div>
            </div>
        </div>
    )
}